const c = "cashbackRecord_GB2lZ", _ = "cashbackRecord__wrapper_GzQH7", a = "cashbackRecord__infoRow_1p88E", o = "cashbackRecord__infoRow__date_MCgcb", e = "cashbackRecord__infoRow__text_TNfDS", s = "cashbackRecord__values_To2C7", R = "cashbackRecord__values__value_smnZE", r = {
  cashbackRecord: c,
  cashbackRecord__wrapper: _,
  cashbackRecord__infoRow: a,
  cashbackRecord__infoRow__date: o,
  cashbackRecord__infoRow__text: e,
  cashbackRecord__values: s,
  cashbackRecord__values__value: R
};
export {
  c as cashbackRecord,
  a as cashbackRecord__infoRow,
  o as cashbackRecord__infoRow__date,
  e as cashbackRecord__infoRow__text,
  s as cashbackRecord__values,
  R as cashbackRecord__values__value,
  _ as cashbackRecord__wrapper,
  r as default
};
//# sourceMappingURL=cashbackRecord.module.scss.js.map
